import logo from "../../../logo.svg";

import './LoadScreenComponent.css';

const LoadScreenComponent = ({}) => {
  return(
    <div className="container">
      <p>cargando...</p>
      {/*<img className="load-logo"  src={logo} alt="chatbot"/>*/}
    </div>
  );
};

export default LoadScreenComponent;
